<template>
  <div class="container-fluid">

    <!-- Listar puntos de venta -->
    <div class="section_list">
      <div class="info">
        <div class="title_info">
          <span>EQUIVALENCIA DE PUNTOS:</span>
        </div>
        <div class="desc_info">
          <b>Nota: </b><span><b>3</b> galones equivalen a <b>1</b> caja</span><br>
          <b>Mineral: </b><span><b>1</b> punto por galón (<b>3</b> puntos por caja)</span><br>
          <b>Semi Synthetic: </b><span><b>2</b> puntos por galón (<b>6</b> puntos por caja)</span><br>
          <b>Full Synthetic: </b><span><b>2</b> puntos por galón (<b>6</b> puntos por caja)</span><br>
        </div>
      </div>

      <table class="table table-striped">
        <thead class="table-dark">
          <tr>
            <th scope="col">Nit</th>
            <th scope="col">Nombre del establecimiento</th>
            <th scope="col">Departamento</th>
            <th scope="col">Ciudad</th>
            <th scope="col">Dirección</th>
            <th scope="col">Email</th>
            <th scope="col">Número telefónico</th>
            <th scope="col">Puntos</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in pointsOfSale" :key="item.id">
            <td>{{ item.document_number }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.state_name }}</td>
            <td>{{ item.city_name }}</td>
            <td>{{ item.address }}</td>
            <td>{{ item.email }}</td>
            <td>{{ item.phone }}</td>
            <td><b>{{ item.amount }}</b></td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>
import axios from 'axios';

export default {
  data(){
    return {
      dataUser: [],
      distributor_id: null,
      pointsOfSale: []
    };
  },
  methods: {
    getDataUser() {
      axios
        .get("api/showUser")
        .then((res) => {
          this.dataUser = res.data.User;
          this.distributor_id = this.dataUser.distributor_id;
          this.getPointsOfSale();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getPointsOfSale(){
      this.pointsOfSale = [];
      axios
      .post('superAdmin/get-points-of-sale/' + this.distributor_id)
      .then((res) => {
        if(res.data.cod == 0){
          this.pointsOfSale = res.data.data;
        } else {
          this.$swal({
            icon: "warning",
            title: "Oops...",
            text: res.data.message,
            confirmButtonColor: "#dc3545"
          });
        }
      })
    },
  },
  watch: {
    
  },
  mounted(){
    this.getDataUser();
  }
};
</script>

<style scoped>
.container-fluid{
  padding: 8% 1% !important;
}
.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, .05) !important;
}
.section_list{
  padding: 40px 5px;
}
.info > .title_info, .info > .desc_info{
  color: black;
}
.info{
  text-align: start;
  padding: 10px 0px;
}
.title_info{
  padding: 0px 0px 5px 0px;
  font-family: "GothamBoldItalic";
}
.desc_info > span > b{
  color: #dc3545;
}


@font-face {
  font-family: "GothamLight";
  src: url('../../../assets/font/GothamLight.ttf');
}
@font-face {
  font-family: "GothamBookItalic";
  src: url('../../../assets/font/GothamBookItalic.ttf');
}
@font-face {
  font-family: "GothamBoldItalic";
  src: url('../../../assets/font/GothamBoldItalic.ttf');
}
</style>
